// import dayjs from "dayjs";

// const generateTimeSheetFullData = () => {
//   const startDate = dayjs("2022-05-01");
//   const endDate = dayjs();
//   const timeSheet = [];
//   const users = [
//     {
//       id: 1,
//       name: "Smithi Raul",
//       clientName: "Client A",
//       workAuthorization: "H-B1",
//       placementType: "Placement-1",
//       invoiceNumber: "INV-123145",
//       invoiceAmount: 100012,
//     },
//     {
//       id: 2,
//       name: "C Raman Babu",
//       clientName: "Client B",
//       workAuthorization: "H-B1",
//       placementType: "Placement-1",
//       invoiceNumber: "INV-22325",
//       invoiceAmount: 1000,
//     },
//   ];

//   // Generate timesheet data for each user
//   users.forEach((user) => {
//     for (
//       let date = startDate;
//       date.isBefore(endDate) || date.isSame(endDate);
//       date = date.add(1, "day")
//     ) {
//       const isWeekend = date.day() === 0 || date.day() === 6;

//       timeSheet.push({
//         userId: user.id,
//         userName: user.name,
//         clientName: user.clientName,
//         workAuthorization: user.workAuthorization,
//         placementType: user.placementType,
//         invoiceNumber: user.invoiceNumber,
//         invoiceAmount: user.invoiceAmount,
//         date: date.toISOString(),
//         working: isWeekend ? "00:00" : "08:00",
//       });
//     }
//   });

//   return timeSheet;
// };

// const TimeSheetFullData = generateTimeSheetFullData();

// export default TimeSheetFullData;

import dayjs from "dayjs";

const generateTimeSheetFullData = () => {
  const startDate = dayjs("2022-05-01");
  const endDate = dayjs();
  const currentMonth = dayjs();
  const lastMonth = currentMonth.subtract(1, 'month');
  const secondLastMonth = currentMonth.subtract(2, 'month');

  const users = [
    {
      id: 1,
      name: "Smithi Raul",
      clientName: "Client A",
      workAuthorization: "H-B1",
      placementType: "Placement-1",
      invoiceNumber: "INV-123145",
      invoiceAmount: 100012,
    },
    {
      id: 2,
      name: "C Raman Babu",
      clientName: "Client B",
      workAuthorization: "H-B1",
      placementType: "Placement-1",
      invoiceNumber: "INV-22325",
      invoiceAmount: 1000,
    },
  ];

  // Generate timesheet data for each user
  const timeSheetData = users.map((user) => {
    const workDetails = [];

    for (
      let date = startDate;
      date.isBefore(endDate) || date.isSame(endDate);
      date = date.add(1, "day")
    ) {
      const isWeekend = date.day() === 0 || date.day() === 6;
      let status = "Pending";

      // Set status based on month
      if (date.isSame(secondLastMonth, 'month')) {
        status = "Submitted";
      } else if (date.isSame(lastMonth, 'month')) {
        status = "Invoiced";
      } else if (date.isSame(currentMonth, 'month')) {
        // For current month, set first 15 days as Approved if not weekend
        if (!isWeekend && date.date() <= 15) {
          status = "Approved";
        }
      }

      workDetails.push({
        date: date.format("YYYY-MM-DD"),
        working: isWeekend ? "00:00" : generateRandomTime(),
        status: status,
      });
    }

    return {
      ...user,
      workDetails,
    };
  });

  return timeSheetData;
};

const generateRandomTime = () => {
  const times = ["06:30", "07:00", "07:30", "08:00", "10:00"];
  return times[Math.floor(Math.random() * times.length)];
};

const TimeSheetFullData = generateTimeSheetFullData();

export default TimeSheetFullData;
